import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { ArrowRight } from "lucide-react";

export default function Signup() {
  const { register, error, setError } = useAuth();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const ok = await register(name, email, password);
    setBusy(false);
    if (ok) navigate("/dashboard");
  };

  return (
    <div className="min-h-[calc(100vh-3.5rem)] bg-white flex items-center justify-center px-6 py-12">
      <div className="w-full max-w-sm">
        <div className="text-center mb-10">
          <span className="notion-emoji-box callout-green mx-auto mb-4">🚀</span>
          <h1 className="font-serif-h text-3xl font-semibold text-[#37352F] mb-2">Create your account</h1>
          <p className="text-[#787774] text-sm">Start scanning in under a minute.</p>
        </div>

        <form onSubmit={submit} className="space-y-3" data-testid="signup-form">
          <div>
            <label className="text-xs font-medium text-[#787774] block mb-1.5">Name</label>
            <input
              type="text"
              required
              value={name}
              onChange={(e) => { setName(e.target.value); setError(""); }}
              data-testid="signup-name-input"
              className="w-full bg-white border border-[#EBEBEA] focus:border-[#2383E2] focus:ring-2 focus:ring-[#D4EBF8] rounded-md px-3.5 py-2.5 text-sm outline-none transition"
              placeholder="Jane Doe"
            />
          </div>
          <div>
            <label className="text-xs font-medium text-[#787774] block mb-1.5">Email</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => { setEmail(e.target.value); setError(""); }}
              data-testid="signup-email-input"
              className="w-full bg-white border border-[#EBEBEA] focus:border-[#2383E2] focus:ring-2 focus:ring-[#D4EBF8] rounded-md px-3.5 py-2.5 text-sm outline-none transition"
              placeholder="you@company.com"
            />
          </div>
          <div>
            <label className="text-xs font-medium text-[#787774] block mb-1.5">Password (min 6)</label>
            <input
              type="password"
              required
              minLength={6}
              value={password}
              onChange={(e) => { setPassword(e.target.value); setError(""); }}
              data-testid="signup-password-input"
              className="w-full bg-white border border-[#EBEBEA] focus:border-[#2383E2] focus:ring-2 focus:ring-[#D4EBF8] rounded-md px-3.5 py-2.5 text-sm outline-none transition"
              placeholder="••••••••"
            />
          </div>

          {error && (
            <div className="callout-red rounded-md text-[#8B2A20] text-sm px-3.5 py-2.5" data-testid="signup-error">
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={busy}
            data-testid="signup-submit-button"
            className="w-full bg-[#2383E2] text-white font-medium py-2.5 rounded-md flex items-center justify-center gap-2 hover:bg-[#1A6FCC] transition-colors disabled:opacity-50 mt-2"
          >
            {busy ? "Creating…" : <>Create account <ArrowRight className="w-4 h-4" /></>}
          </button>
        </form>

        <p className="mt-8 text-sm text-[#787774] text-center">
          Already have an account? <Link to="/login" data-testid="signup-to-login-link" className="text-[#2383E2] hover:underline font-medium">Sign in</Link>
        </p>
      </div>
    </div>
  );
}
